import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=56ed29eb&"
import script from "./TeacherCreate.vue?vue&type=script&lang=js&"
export * from "./TeacherCreate.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCreate.vue?vue&type=style&index=0&id=56ed29eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports